module.exports = __webpack_public_path__ + "img/event-webinair-2020.3ae7f0b0.jpg";